<template>
  <RadioTags v-model="operationType"
             :options="operationTypeList"
             name="deal-type"/>
</template>

<script>
import {mapState} from "vuex";
import RadioTags from "@/components/UI/RadioTags";

export default {
  name: "CreateTransactionType",
  components: {RadioTags},
  props: {
    operation: {
      type: Number,
      required: true
    },
    syncBanksAvailable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('space/accounts', ['accounts']),
    operationType: {
      get() {
        return this.operation;
      },
      set(value) {
        this.$emit('changeType', value);
      }
    },
    transferDisabled() {
      return this.accounts.data.length < 2;
    },
    operationTypeList() {
      const operationTypes = [
        {value: 2, text: this.$t('expense'), color: 'red'},
        {value: 1, text: this.$t('income'), color: 'green'},
        {
          value: 3,
          text: this.$t('transfer'),
          color: 'yellow',
          disabled: this.transferDisabled,
          tooltip: this.transferDisabled ? this.$t('transferDisabledTooltip') : ''
        },
        {value: 4, text: this.$t('sync'), color: '', classes: 'ml-8', hidden: !this.syncBanksAvailable},
      ]
      return operationTypes.filter(item => !item.hidden)
    },
  },
  i18n: {
    messages: {
      en: {
        income: 'Income',
        expense: 'Expense',
        transfer: 'Transfer',
        transferDisabledTooltip: "You need to have 2 or more accounts <br> to create a transfer",
        sync: 'Synchronization',
      },
      ru: {
        income: 'Доход',
        expense: 'Расход',
        transfer: 'Перевод',
        transferDisabledTooltip: "У вас должно быть 2 или более счетов <br> для совершения перевода",
        sync: 'Синхронизация',
      }
    }
  }
}
</script>